import {
  DataFilterDefinitionsDtoResponse,
  DataTableDataSearchDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { portalGatewayClient } from '../portalGatewayClient';

export type CustomTableFilterQueryKey = readonly [
  widgetId: string,
  columnKeys: string[],
  pageFilterSelections: DataTableDataSearchDto['selection'],
  selection?: DataTableDataSearchDto['selection'],
  ...string[],
];

export const fetchCustomTableFilterData: QueryFunction<
  DataFilterDefinitionsDtoResponse,
  QueryKeyWithRole<CustomTableFilterQueryKey>
> = async ({ queryKey }) => {
  const [widgetId, columnKeys, pageFilterSelections, selection] =
    unwrapQueryKeyWithRole(queryKey).params;

  try {
    const response =
      await portalGatewayClient.table.searchCustomTableFilterData(widgetId, {
        filters: pageFilterSelections,
        selection,
        columnKeys,
      });

    return response.data;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
